import "./locales";

import store, { persistor } from "./store";

import { BrowserRouter } from "react-router-dom";
import Layout from "components/layout";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import Theme from "components/template/Theme";
import appConfig from "configs/app.config";
import history from "./history";
import mockServer from "./mock";

const environment = process.env.NODE_ENV;

if (appConfig.enableMock) {
  mockServer({ environment });
}




function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter history={history}>
          <Theme>
            <Layout />
          </Theme>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}

export default App;
